import {action, makeAutoObservable, observable} from 'mobx';
import {OptionsObject, SnackbarKey, SnackbarMessage} from "notistack";

interface NotificationObj {
    key: SnackbarKey,
    message: SnackbarMessage,
    options?: OptionsObject
}

class NotificationStore {
    readonly notificationsToShow = observable<NotificationObj>([])
    readonly notificationsToHide = observable<SnackbarKey>([])

    constructor() {
        makeAutoObservable(this);
    }

    @action
    public addNotification(message: SnackbarMessage, options?: OptionsObject) {
        const key = options?.key ?? new Date().getTime().toString() + Math.random();
        this.notificationsToShow.push({
            key: key,
            message,
            options: {
                ...options, key: key,
            }
        })
        return key;
    }

    @action
    public hideNotification(key: SnackbarKey) {
        this.notificationsToHide.push(key)
    }

    @action
    public onNotificationShown(keys: SnackbarKey[]) {
        keys.forEach(key => {
            const obj = this.notificationsToShow.find(it => it.key === key);
            if (obj) {
                this.notificationsToShow.remove(obj)
            }
        })
    }

    @action
    public onNotificationHidden(keys: SnackbarKey[]) {
        keys.forEach(key => {
            this.notificationsToHide.remove(key)
        })
    }
}

export const notificationStore = new NotificationStore();

